export const inventoryColumns = [
  {
    field: "zoneID",
    headerName: "Zone ID",
    sortable: false,
    align: "left",
    flex: 1.3,
    minWidth: 130,
  },
  {
    field: "locationID",
    headerName: "Location ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    sortable: false,
    align: "left",
    flex: 1.8,
    minWidth: 180,
  },
  {
    field: "palletNbr",
    headerName: "Pallet Nbr",
    sortable: false,
    align: "left",
    flex: 1.2,
    minWidth: 112,
  },{
    field: "cartonID",
    headerName: "Carton ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "mln",
    headerName: "MLN",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "removeMLN",
    headerName: "Remove MLN",
    sortable: false,
    align: "center",
    flex: 1,
    type: "boolean",
    minWidth: 100,
    editable: true,
    headerClassName: 'custom-editable-header',
  },
  {
    field: "newMLN",
    headerName: "New MLN",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
    editable: true,
    headerClassName: 'custom-editable-header',
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 130,
  },
  {
    field: "removeExpiryDate",
    headerName: "Remove Expiry Date",
    sortable: false,
    align: "center",
    flex: 1,
    type: "boolean",
    minWidth: 100,
    editable: true,
    headerClassName: 'custom-editable-header',
  },
  {
    field: "newExpiryDate",
    headerName: "New Expiry Date",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 190,
    editable: true,
    type: 'date',
    headerClassName: 'custom-editable-header',
  },
  {
    field: "quantity",
    headerName: "Total Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "quantityAvailable",
    headerName: "Quantity Available",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "vendorCode",
    headerName: "Vendor Code",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "packType",
    headerName: "Pack Type",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "oln",
    headerName: "OLN",
    sortable: false,
    align: "left",
    flex: 1.2,
    minWidth: 112,
  },
];